import React from 'react';
import { cn } from '@hero/web-lib';

export interface DrawerContentProps {
  children: React.ReactNode;
  className?: string;
}

export const DrawerContent: React.FC<DrawerContentProps> = ({
  children,
  className,
}) => {
  return (
    <div className={cn('flex-1 overflow-auto', className)}>
      {children}
    </div>
  );
};
